import { c as _c } from "react/compiler-runtime";
import React from "react";
import { TitleCompProps } from "./types";

// Title Component
export function TitleComp(t0) {
  const $ = _c(2);
  const {
    minSlots,
    isVisible
  } = t0;
  if (!isVisible) {
    return null;
  }
  const t1 = `Minimum ${minSlots} slots are required.`;
  let t2;
  if ($[0] !== t1) {
    t2 = <p className="text-red-500 text-xs leading-5">{t1}</p>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
}